import {
    map,
    latLng,
    tileLayer,
    marker,
    icon,
    type MapOptions, featureGroup, Marker,
} from "leaflet";

import type ProjectionPlace from "./interfaces/ProjectionPlace.ts";

const options: MapOptions = {
    center: latLng(45.508889, -73.554167),
    zoom: 12
}

if (document.getElementById("grid-map") != null) {
    const gridMap = map("grid-map", options);

    tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(gridMap);

    let places: ProjectionPlace[] = JSON.parse((document.getElementById("locations-data")! as HTMLScriptElement).text);
    places = places.filter(place => place.latitude && place.longitude);

    const markers: Marker[] = []
    for (const place of places) {
        const placeMarker = marker(latLng(place.latitude!, place.longitude!), {
            title: place.name,
            icon: icon({
                iconUrl: "/wp-content/plugins/funambules-grille-dev/js/mapview/marker.svg",
                iconSize: [48, 48],
            })
        });

        placeMarker.on("click", (e) => {
            let placesFilter = document.getElementById("projection-places-filter") as HTMLSelectElement | null;
            if (!placesFilter) {
                return;
            }

            placesFilter.value = place.slug;
            placesFilter.dispatchEvent(new Event('change'));
        })

        placeMarker.on("popupclose", (e) => {
            let placesFilter = document.getElementById("projection-places-filter") as HTMLSelectElement | null;
            if (!placesFilter) {
                return;
            }

            placesFilter.value = "all";
            placesFilter.dispatchEvent(new Event('change'));
        })

        placeMarker.bindPopup(place.name);

        markers.push(placeMarker);
        placeMarker.addTo(gridMap);
    }

    gridMap.fitBounds(featureGroup(markers).getBounds());
}
